import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { CommonSelectionInterface } from "../../share/interface/common.interface";
import { Observable } from "rxjs";
import {
  O2OPartnerProtectionAddInterface,
  O2OPartnerProtectionEditInterface,
  O2OPartnerProtectionListingInterface
} from "../interfaces/o2o-partner.interface";
import { map } from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class O2OPartnerProtectionService {
  private basePath: string = `${environment.url}/api/O2OPartnerProtection`;

  constructor(private http: HttpClient) {}

  add(id: string, payload: O2OPartnerProtectionAddInterface) {
    const formData = new FormData();
    formData.append("protectionTypeId", payload.protectionTypeId);
    formData.append("insurerId", payload.insurerId);
    formData.append("title", payload.title);
    formData.append("description", payload.description);
    formData.append("insurerEmails", payload.insurerEmails);
    formData.append("catalog", payload.catalog[0]);

    return this.http.post(`${this.basePath}/Add/${id}`, formData);
  }

  getListing(
    id: string,
    limit: number,
    offset: number,
    text = "",
    columnIndex = 0,
    sortDirection = "desc"
  ) {
    return this.http
      .post<{
        count: number;
        data: O2OPartnerProtectionListingInterface[];
      }>(`${this.basePath}/GetListing/${id}`, {
        limit,
        offset,
        text,
        columnIndex,
        sortDirection
      })
      .pipe(
        map((res) => ({
          ...res,
          data: res.data.map((p) => {
            if (p.catalog) {
              p.catalog.UI_isDeleted = false;
              p.catalog.UI_fileType = `image/${p.catalog.fileName.split(".").pop()}`;
            }

            return p;
          })
        }))
      );
  }

  getProtectionTypes(): Observable<CommonSelectionInterface[]> {
    return this.http.get<CommonSelectionInterface[]>(
      `${this.basePath}/GetProtectionTypes`
    );
  }

  getInsurersByProtectionTypeId(
    id: string
  ): Observable<CommonSelectionInterface[]> {
    return this.http.get<CommonSelectionInterface[]>(
      `${this.basePath}/GetInsurersByProtectionTypeId/${id}`
    );
  }

  update(partnerId: string, payload: O2OPartnerProtectionEditInterface) {
    const formData = new FormData();
    for (const payloadKey in payload) {
      formData.append(payloadKey, payload[payloadKey]);
    }

    return this.http.post(`${this.basePath}/Update/${partnerId}`, formData);
  }

  delete(id: string, protectionId: string) {
    return this.http.post(
      `${this.basePath}/Delete/${id}`,
      JSON.stringify(protectionId),
      {
        headers: { "Content-Type": "application/json" }
      }
    );
  }
}
